<template>
  <div class="tw-relative">
    <v-img
      :src="section.data.image_desktop"
      class="tw-hidden sm:tw-flex"
      :class="[desktopClasses]"
    />
    <v-img
      :src="section.data.image_mobile"
      class="sm:tw-hidden"
      :class="[mobileClasses]"
    />

    <!-- CTA -->
    <div v-if="validSection.has_cta" class="bz-buttons tw-absolute tw-top-0 tw-w-full tw-h-full">
      <template v-if="validSection.is_btn_cta">
        <!-- Botón CTA -->
        <v-btn
          v-if="validSection.cta_link_type === 'external'"
          rounded
          :href="validSection.cta_link"
          :class="`bz-btn-${validSection.cta_link_type}`"
          target="_blank"
        >
          {{ validSection.cta_label }}
        </v-btn>
        <v-btn
          v-else
          rounded
          :class="`bz-btn-${validSection.cta_link_type}`"
          :to="resolveInternalLink(validSection.cta_link)"
        >
          {{ validSection.cta_label }}
        </v-btn>
      </template>
      <template v-else>
        <!-- Enlace que cubre toda la imagen -->
        <a v-if="validSection.cta_link_type === 'external'" :href="validSection.cta_link" target="_blank" class="overlay_image_link" />
        <router-link v-else :to="resolveInternalLink(validSection.cta_link)" class="overlay_image_link" />
      </template>
    </div>
  </div>
</template>

<script>
import { ImageRatio } from '@/models/RegistryLanding'
const ratios = {
  width: [
    'tw-aspect-w-1',
    'tw-aspect-w-2',
    'tw-aspect-w-3',
    'tw-aspect-w-4',
    'tw-aspect-w-5',
    'tw-aspect-w-6',
    'tw-aspect-w-7',
    'tw-aspect-w-8',
    'tw-aspect-w-9',
    'tw-aspect-w-10',
    'tw-aspect-w-11',
    'tw-aspect-w-12',
    'tw-aspect-w-13',
    'tw-aspect-w-14',
    'tw-aspect-w-15',
    'tw-aspect-w-16',
  ],

  height: [
    'tw-aspect-h-1',
    'tw-aspect-h-2',
    'tw-aspect-h-3',
    'tw-aspect-h-4',
    'tw-aspect-h-5',
    'tw-aspect-h-6',
    'tw-aspect-h-7',
    'tw-aspect-h-8',
    'tw-aspect-h-9',
    'tw-aspect-h-10',
    'tw-aspect-h-11',
    'tw-aspect-h-12',
    'tw-aspect-h-13',
    'tw-aspect-h-14',
    'tw-aspect-h-15',
    'tw-aspect-h-16',
  ],
}
export default {
  props: {
    section: {
      type: Object,
      default: () => ({}),
    },
    slug: {
      type: String,
      default: '',
    },
  },

  computed: {
    validSection() {
      return { ...ImageRatio(), ...this.section.data }
    },
    desktopClasses() {
      return `${ratios.width[this.section.data.ratio_desktop_x - 1]} ${
        ratios.height[this.section.data.ratio_desktop_y - 1]
      }`
    },
    mobileClasses() {
      return `${ratios.width[this.section.data.ratio_mobile_x - 1]} ${
        ratios.height[this.section.data.ratio_mobile_y - 1]
      }`
    },
  },
  methods: {
    resolveInternalLink(key) {
      const params = { slug: this.slug }
      return {
        register: { name: 'registry.register', params },
        login: { name: 'registry.login', params },
      }[key] || { name: 'registry.register', params }
    },
  },
}
</script>

<style></style>
